import React from 'react'
import { useIntl } from 'react-intl'

import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot
} from 'mailup-web-components'
import { discardCallback } from '../recoil/callbacks/callbacks'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { modalConfirmDiscardState } from '../recoil/state/state'

const ModalConfirmDiscard = () => {
  const intl = useIntl()
  const discard = useRecoilCallback(discardCallback, [])
  const [modalConfirm, setModalConfirm] = useRecoilState(
    modalConfirmDiscardState
  )

  const handleConfirm = () => {
    discard()
  }

  const handleClose = () => {
    setModalConfirm(prev => ({ prev, show: false }))
  }

  return (
    <Modal
      data-mu-test='modal-confirm-leave'
      show={modalConfirm.show}
      onClose={handleClose}
      showClose
      closeOnOverlayClick
      size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ContentDefaults.ResetConfirmTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.ContentDefaults.ResetConfirmBody'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='neutral'
          onClick={handleClose}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Cancel'
          })}
        </Button>
        <Button
          kind='danger'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({
            id: 'Load.ContentDefaults.ResetConfirmBtn'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalConfirmDiscard
